module.exports = __webpack_public_path__ + "static/img/banner_ucenter.419085b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_ucenter.jpg
// module id = EAi2
// module chunks = 2